import React from 'react';
import Navbar from '../Components/Landingpage/Navbar';
import Hero from '../Components/Landingpage/Hero';
import Features from '../Components/Landingpage/Features';
import About from '../Components/Landingpage/About';
import Services from '../Components/Landingpage/Services';
import Pricing from '../Components/Landingpage/Pricing';
import Attractions from '../Components/Landingpage/Attractions';
import Blog from '../Components/Landingpage/Blog';
import Testimonial from '../Components/Landingpage/Testimonial';
import Footer from '../Components/Landingpage/Footer';
import BackToTop from '../Components/Landingpage/BackToTop';

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <Features />
      <About />
      <Services />
      {/* <Pricing /> */}
      <Attractions />
      <Blog />
      <Testimonial />
      <Footer />
      <BackToTop />
    </>
  );
};

export default Home;
